module.exports = __webpack_public_path__ + "img/hf-holz-techniker-studienschwerpunkte.9e4e77e9.jpg";